import React, { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import icon from "../images/icon.png";
import headset from "../images/headset.png";

import "./HeroSection.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const public_Key = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Form state
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  // const [status, setStatus] = useState(null);

  const toggleMenu = () => setIsMenuActive(!isMenuActive);
  const closeMenu = () => setIsMenuActive(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY >= 75);

    // Initialize scroll state
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768 && isMenuActive) {
        setIsMenuActive(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMenuActive]);

  const socialLinks = {
    facebook: "https://www.facebook.com/yourpage",
    instagram: "https://www.instagram.com/yourprofile",
    twitter: "https://twitter.com/yourhandle",
    youtube: "https://www.youtube.com/yourchannel",
  };

  // ===== EMAIL SENDING FUNCTION =====

  const form = useRef();

  // ======================================================
  // 🚀 SEND EMAIL USING FIREBASE CLOUD FUNCTION
  // ======================================================

const sendEmail = async (e) => {
  e.preventDefault();

  if (!firstName || !lastName || !email || !message) {
    toast.error("All fields are required");
    return;
  }

  try {
    const response = await fetch("https://us-central1-training-app-b5767.cloudfunctions.net/sendEmail", {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        message
      }),
    });

    const data = await response.json();
    console.log("Response:", data);

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    toast.success("Message sent successfully!");
    setFirstName("");
    setLastName("");
    setEmail("");
    setMessage("");
    
  } catch (err) {
    console.error("Email Error:", err);
    toast.error("Failed to send message: " + err.message);
  }
};


  // ======================================================
  //                PAGE LAYOUT + NAVIGATION
  // ======================================================

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }}
      />

      <header className={`header ${isScrolled ? "on-scroll" : ""}`} id="header">
        <nav className="navbarCustom container">
          <a href="#" className="brand">
            Newtech
          </a>
          <img
            src={icon}
            alt="My Icon"
            style={{ width: "25px", height: "25px", marginLeft: "-10px" }}
          />
          <div
            className={`burger ${isMenuActive ? "is-active" : ""}`}
            onClick={toggleMenu}
          >
            <span className="burger-line"></span>
            <span className="burger-line"></span>
            <span className="burger-line"></span>
          </div>

          <div className={`menu ${isMenuActive ? "is-active" : ""}`}>
            <ul className="menu-inner">
              {[
                { name: "Home", id: "home" },
                { name: "About", id: "about" },
                { name: "Contact", id: "contact" },
              ].map(({ name, id }) => (
                <li key={name} className="menu-item">
                  <a href={`#${id}`} className="menu-link" onClick={closeMenu}>
                    {name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <span
            className={`overlay ${isMenuActive ? "is-active" : ""}`}
            onClick={closeMenu}
          ></span>

          {/* <button type="button" className="menu-block">
            <a href="#" className="btn btn-neutral">Register</a>
          </button> */}
        </nav>
      </header>

      {/* ================================== */}
      {/* HERO SECTION */}
      {/* ================================== */}

      <main className="main">
        <section className="section contact-section" id="home">
          <div className="container banner-column">
            <img
              src={headset}
              className="banner-image"
              alt="Headphones"

            />

            <div className="banner-inner">
              <h1 className="title-large">Services Interpretation</h1>
              <p className="text-base font-normal">
                We take your communication to the next level with a team of
                highly skilled interpreters and in-depth knowledge of various
                industries (Medical, Insurance, Agriculture, Court, and
                Education for both OPI and VRI), We ensure that your message is
                conveyed accurately and professionally.
              </p>

              <p className="text-base font-normal">
                Understanding the importance of details and context, we go the
                extra mile to provide exceptional interpretation services. From
                important business meetings to cultural events, we are the
                reliable partner you can count on.
              </p>

              <a href="#contact" className="btn btn-primary">
                Contact us <i className="bx bx-chevron-right"></i>
              </a>
            </div>

            <div className="banner-link">
              {Object.entries(socialLinks).map(([platform, url]) => (
                <a
                  key={platform}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={platform}
                >
                  <i className={`bx bxl-${platform}`}></i>
                </a>
              ))}
            </div>
          </div>
        </section>


        {/* ================================== */}
        {/* ABOUT SECTION */}
        {/* ================================== */}

        <section className="section .about-section" id="about">
          <div className="container">
            <div className="banner-inner">
              <h1 className="title-large">About</h1>
              <p className="text-base font-normal">
                At NEWTECH CONTACT CENTER, we are passionate about providing
                exceptional interpretation services to our clients. With a
                dedicated team and years of experience, we have established
                ourselves as leaders in the industry.
              </p>

              <p className="text-base font-normal">
                Our journey began with a vision to bridge communication gaps and
                foster understanding across cultures. We take pride in our
                diverse team, comprising of skilled interpreters fluent in
                multiple languages.
              </p>

              <p className="text-base font-normal">
                Over the years, we have been recognized for our commitment to
                excellence and have received numerous awards for our outstanding
                services. Our dedication to professionalism and quality has
                helped us build lasting relationships with clients across the
                globe.
              </p>
            </div>
          </div>
        </section>

        {/* ================================== */}
        {/* CONTACT FORM */}
        {/* ================================== */}

        <section className="section contact-section" id="contact">
          <div className="container">
            <h1 className="title-large">Contact Us</h1>

            <form ref={form} className="contact-form" onSubmit={sendEmail}>
              <div className="form-group">

                <div className="form-field">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>

                <div className="form-field">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>

              </div>

              <div className="form-field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Send
              </button>

            </form>
          </div>
        </section>
      </main>

      <link
        rel="stylesheet"
        href="https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css"
      />
    </>
  );
};

export default App;
